import React, {useEffect, useState, useRef, useCallback} from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, InputLabel, InputBase } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import {Tooltip } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { useTranslation } from 'react-i18next';

import { updateHeadCell } from '../../../actions/batchManagementActions';

const useStyles = makeStyles((theme)=> ({
    dialogPaper: {
        minHeight: '80vh'
    }
}))


function PaperComponent(props) {
    return (
      <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
        <Paper {...props} />
      </Draggable>
    );
}
  
export default function ChooseColumnDialog(props) {
    const { openModal, onClose} = props;

    const classes = useStyles();
    const {t} = useTranslation('batchManagement');
    const dispatch = useDispatch();

    const ROW_MAX_COLUMN = 8;
    const COLUMN_SHOW = 0;
    const COLUMN_SELECT_DEFAULT = '0';    //column shows by default
    const COLUMN_SELECT_RECENT = '1';     //column shows by recent setting
    const COLUMN_SELECT_ALL = '2';        //column shows all 

    const columnSelectList = useSelector(state => state.batchManagement.columnSelectList) || [];
    const headCellList = useSelector(state => state.batchManagement.headCellList) || [];

    const [columnSelect,setColumnSelect] = useState(COLUMN_SELECT_RECENT);
    const [headCellState, setHeadCellState] = useState([]);

    useEffect(() => {      
        if (openModal === true)  {
            //initialization the variable
            init();
        }        
    },[openModal]);    

    return (        
            <Dialog 
                open={openModal}
                onClose={handleClose} 
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
                fullWidth={true}
                maxWidth='xl'
                scroll='body'
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    {t('title_choose_columns')}
                    <span style={{float: "right"}}>
                        <FormControl component="fieldset">
                            {/* <FormLabel component="legend">Gender</FormLabel> */}
                            <RadioGroup 
                                name="columnSelect" 
                                value={columnSelect} 
                                onChange={(e)=>handleColumnSelectChange(e)}
                                style={{display: 'flex', flexDirection: 'row', paddingRight: 16}}
                            >
                                {
                                    columnSelectList.map((item,index)=>(
                                        <FormControlLabel key = {index}
                                            control={<Radio />}
                                            label={t(item.label)} 
                                            value={item.value}
                                        />
                                    ))
                                }                            
                            </RadioGroup>
                        </FormControl>
                        <Tooltip title={t('common:cancel')} aria-label="cancel" >
                            <CloseIcon onClick={handleClose}></CloseIcon>
                        </Tooltip>        
                    </span>
                </DialogTitle>
                <DialogContent dividers>
                {
                    (headCellState.length > 0) && headCellState.map((item,index)=>( 
                        index % ROW_MAX_COLUMN === 0 
                        ?
                        <div style={{display: 'flex', flexDirection: 'row', paddingBottom: 16}} key={item + index}>
                            {                                
                                headCellState.map((ele,idx)=>{
                                    if (   
                                         (idx >= ((index / ROW_MAX_COLUMN) * ROW_MAX_COLUMN)) && 
                                         (idx < ((index / ROW_MAX_COLUMN + 1) * ROW_MAX_COLUMN))
                                        ) {
                                        return (
                                            <FormControlLabel key={ele.id}
                                            control={
                                            <Checkbox 
                                                checked={ele.checked}
                                                disabled={ele.id==="dispatch_no" || ele.id==="master_air_waybill"}
                                                onChange={(e)=>(setHeadCellState(headCellState.map(
                                                    (ele1,idx1)=>
                                                        (ele1.id === ele.id)   
                                                        ?
                                                        {...ele1, checked: e.target.checked}
                                                        :                                            
                                                        ele1
                                                    )
                                                ))}
                                                name={ele.id}
                                            />
                                            }
                                            label={t(ele.label)}
                                            style={{width: 200, paddingRight: 20}}
                                        />    
                                    )}
                                })
                            }                            
                        </div>                        
                        :
                        null
                    ))
                }    

                </DialogContent>  
                <DialogActions>
                    <Button autoFocus onClick={handleSave} color="primary">
                        {t('common:save')}
                    </Button>
                    <Button autoFocus onClick={handleClose} color="primary">
                        {t('common:cancel')}
                    </Button>
                    </DialogActions>                          
            </Dialog>
    )


    /**
     * init
     */
    function init() {
        // load the columns
        let headCells = [];

        headCells = JSON.parse(localStorage.getItem("head_cells") || '[]').filter((item)=>(item.hidden === COLUMN_SHOW)) ;
        if  (headCells.length === 0) {
            headCells = headCellList.filter((item)=>(item.hidden === COLUMN_SHOW));
        }        
        setHeadCellState(headCells);
    };
    /**
     * save the change to the localstorage
     */
    function handleSave() {    
        dispatch(updateHeadCell(headCellState));
        localStorage.setItem("head_cells",JSON.stringify(headCellState));
        handleClose();
        //console.log("****headCellState.JSON:",JSON.stringify(headCellState));
    };

    /**
     * Close the MessageSnackbar
     * Call the prarent function to handle the status after this dialoge is closed
     */
    function handleClose() {    
        onClose();
    };


    /**
     * check the columns that will be showed next time
     */
    function handleColumnSelectChange(e) {
        let headCells = [];

        if (e.target.value === COLUMN_SELECT_DEFAULT) {            
            headCells = headCellList.filter((item)=>(item.hidden === COLUMN_SHOW)).concat();
            headCells.map((item,index)=>( item.default === 1 ? item.checked = 1: item.checked = 0));
        }

        if (e.target.value === COLUMN_SELECT_RECENT) {            
            // load the columns
            headCells = localStorage.getItem("head_cells") || [] ;            
            if(headCells.length === 0) {
                headCells = headCellList.filter((item)=>(item.hidden === COLUMN_SHOW));
                headCells.map((item,index)=>( item.default === 1 ? item.checked = 1: item.checked = 0));
            } else {
                headCells = JSON.parse(headCells);
            }            
        }

        if (e.target.value === COLUMN_SELECT_ALL) {
            headCells = headCellList.filter((item)=>(item.hidden === COLUMN_SHOW));
            headCells.map((item,index)=>( item.checked === 0 ? item.checked = 1: null));            
        }        

        setColumnSelect(e.target.value);
        setHeadCellState(headCells);        
    }

}

